import { faChevronLeft, faRefresh, faRotateRight, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';

import { Props } from '@/components/Fallback/types';
import Accordion from '@/ui/components/Accordion';
import Alert from '@/ui/components/Alert';
import Button from '@/ui/components/Button';
import Container from '@/ui/components/Container';

const Fallback = ({ error, personId, resetError }: Props) => {
  const navigate = useNavigate();

  const reload = () => window.location.reload();

  return (
    <Container type="page">
      <div className="flex justify-center space-x-2 text-center">
        <div className="p-1 space-y-2">
          <Button
            color="white"
            type="button"
            onClick={() => {
              navigate(-1);
              reload();
            }}
            size="xs">
            <FontAwesomeIcon color="black" icon={faChevronLeft} className="mr-1" />
            Go back
          </Button>
        </div>

        {personId && (
          <div className="p-1 space-y-2">
            <Button
              color="white"
              type="button"
              onClick={() => navigate(`/people/${personId}/profile/`)}
              size="xs">
              <FontAwesomeIcon color="black" icon={faUser} className="mr-1" />
              Go to Profile
            </Button>
          </div>
        )}
      </div>

      <div className="space-y-2">
        <Alert level="error" message="An error has occurred. The team has been notified." />

        <div>
          <Accordion buttonText="Error details">
            <pre className="text-xs text-red-800 bg-red-50 border-red-200 p-4 whitespace-normal">
              {error instanceof Error ? error.toString() : String(error)}
            </pre>
          </Accordion>
        </div>

        <div className="flex divide-x divide-gray-600 justify-center space-x-2 text-center">
          <div className="p-4 space-y-2">
            <Button onClick={resetError} type="button">
              <FontAwesomeIcon icon={faRotateRight} className="mr-1" />
              Try again
            </Button>

            <p>Retry the action that caused the error.</p>
          </div>

          <div className="p-4 space-y-2">
            <Button color="white" type="button" onClick={reload}>
              <FontAwesomeIcon color="black" icon={faRefresh} className="mr-1" />
              Refresh
            </Button>

            <p>If the error persists, try refreshing the page.</p>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Fallback;
